// Empty brief scaffold used when the user skips AI or the LLM is disabled.
export function emptyBrief(intake = {}) {
  return {
    kyc: {
      company_description: "",
      sector: intake.industry || "",
      employee_count: "",
      countries: intake.country ? [intake.country] : [],
      certifications: "",
    },
    structure: {
      modality: "blended",
      session_format: "en_vivo",
      region: "LATAM",
      program_type: "diplomado",
      language: "es-LATAM",
      endorsements: ["DCC"],
    },
    logistics: {
      attendees_total: intake.audience_size || 0,
      attendees_per_group: 0,
      start_date: "",
      end_date: "",
      preferred_schedule: "",
      session_duration_hours: 2,
      periodicity: "semanal",
    },
    content: {
      thematic_areas: [],
      training_name: "",
      objective: "",
      modules_count: 0,
      suggested_program_ids: [],
      graduate_profile: "",
      materials: [],
      bibliography: "",
      didactic_resources: [],
      evaluation: [],
    },
    operations: {
      requires_confirmation: {
        current_lms: null,
        internal_training_staff: null,
        team_for_promotion: null,
        team_for_enrollment: null,
        team_for_coordination: null,
      },
      technical_requirements: [],
      communication_channels: [],
      promotion_materials: [],
    },
    overall_reasoning: "",
  };
}

// Duration string based on total training hours.
export function durationLabel(hours) {
  if (hours <= 20) return "20h";
  if (hours <= 40) return "40h";
  if (hours <= 60) return "60h";
  if (hours <= 80) return "80h";
  return "100h+";
}
